export enum LineItemTab {
  LINE_INFO = 'Line Info',
  CENSUS_WARNINGS = 'Census Warnings',
}
